var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAlertTriangle = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 1024 1024"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 4,
  strokeWidth: 71.68,
  d: "M511.99 383.926v170.667m0 170.666h.427m414.718 42.667L585.802 170.593c-7.441-13.132-18.234-24.056-31.276-31.655a85.34 85.34 0 0 0-85.924 0 85.34 85.34 0 0 0-31.278 31.655L95.991 767.926a85.331 85.331 0 0 0 74.666 128h682.665a85.4 85.4 0 0 0 42.638-11.463 85.4 85.4 0 0 0 31.198-31.243c7.481-12.965 11.418-27.676 11.412-42.65s-3.948-29.679-11.435-42.644"
})));
export default SvgAlertTriangle;